import {
  ChangeDetectionStrategy,
  Component, destroyPlatform,
  EventEmitter,
  Inject,
  Input, OnInit,
  Output
} from "@angular/core";
import {RouteModel} from "../../../../routes/models/route.model";
import {routeActionsByStatus} from "../../constants/lean-planning.constant";
import {TaskModel} from "../../../../tasks/models/task.model";

require('./planning-routes-table-row.scss');
@Component({
  standalone: false,
  selector: 'app-planning-routes-table-row',
  templateUrl: './planning-routes-table-row.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlanningRoutesTableRowComponent {

  @Input() route: RouteModel;
  @Input() isSelected: boolean;
  @Input() show: boolean;
  @Input() highlighted: boolean;
  @Input() columns: any;
  @Input() dynamicColumns: any;
  @Input() hasFleetManagementPermission: boolean;
  @Input() serviceAreasMap: any;

  @Output() onToggle = new EventEmitter<RouteModel>();
  @Output() onAssignRoute = new EventEmitter<RouteModel>();
  @Output() onAssignRouteAndSelectDriver = new EventEmitter<RouteModel>();
  @Output() onHandleUnpackedDeliveries = new EventEmitter<RouteModel>();
  @Output() onReoptimizeRoute = new EventEmitter<string>();
  @Output() onBlockRoute = new EventEmitter<string>();
  @Output() onUnBlockRoute = new EventEmitter<string>();
  @Output() onResetRoute = new EventEmitter<RouteModel>();
  @Output() onUpdateBranches = new EventEmitter<RouteModel>();
  @Output() onUpdateResource = new EventEmitter<RouteModel>();
  @Output() onManageAssistants = new EventEmitter<RouteModel>();
  @Output() onChangeRouteColor = new EventEmitter<RouteModel>();
  @Output() onUpdateLogisticsVehicle = new EventEmitter<{ task: TaskModel, route: RouteModel }>();
  @Output() onDeleteRoute = new EventEmitter<RouteModel>();
  @Output() onToggleShowRoute = new EventEmitter<RouteModel>();

  @Output() onPrintIkea = new EventEmitter<RouteModel>();
  @Output() onExport = new EventEmitter<string>();
  @Output() onDownloadBillOfLading = new EventEmitter<string>();
  @Output() onPrintBillOfLading = new EventEmitter<string>();
  @Output() onPrintLoadingSheet = new EventEmitter<string>();
  @Output() onPrint = new EventEmitter<string>();

  public canCopyRouteId: boolean;

  constructor() {
  }
}
